/**
 * List of events used by profile-data
 *
 */
export const profileData = {
  NAME_CHANGED: 'profileData.nameChanged',
  DATA_OPENED: 'profileData.dataOpened',
  DATA_EDITED: 'profileData.dataEdited'
}
